/* Shipping badge — recalculates the ship-by date and picks the destination flag.
   Runs on every page load so a CDN-cached page can't show yesterday's date.
   The origin timezone comes from the snippet (shop.iana_timezone), so the
   JavaScript and the Liquid always count in the same timezone. */
(function () {
  var FALLBACK_TZ = 'Australia/Sydney';
  var NZ_TIMEZONES = /^Pacific\/(Auckland|Chatham)$/;
  function todayIn(timeZone) {
    var iso;
    try {
      iso = new Intl.DateTimeFormat('en-CA', {
        timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      iso = new Intl.DateTimeFormat('en-CA', {
        timeZone: FALLBACK_TZ, year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    }
    return new Date(iso + 'T12:00:00Z');
  }
  function shipBy(leadDays, holidays, originTz) {
    var day = todayIn(originTz);
    var counted = 0;
    var guard = 0;
    while (counted < leadDays && guard < 90) {
      day.setUTCDate(day.getUTCDate() + 1);
      guard++;
      var weekday = day.getUTCDay();
      var iso = day.toISOString().slice(0, 10);
      if (weekday !== 0 && weekday !== 6 && holidays.indexOf(iso) === -1) counted++;
    }
    return ('0' + day.getUTCDate()).slice(-2) + '/' + ('0' + (day.getUTCMonth() + 1)).slice(-2);
  }
  function visitorCountry() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (NZ_TIMEZONES.test(tz)) return 'NZ';
    } catch (e) {}
    if (/-NZ$/i.test(navigator.language || '')) return 'NZ';
    return 'AU';
  }
  function render(badge) {
    var leadDays = parseInt(badge.getAttribute('data-lead-days'), 10) || 3;
    var holidays = (badge.getAttribute('data-holidays') || '').split(',');
    var originTz = badge.getAttribute('data-tz') || FALLBACK_TZ;
    var dateEl = badge.querySelector('[data-ship-date]');
    if (dateEl) dateEl.textContent = shipBy(leadDays, holidays, originTz);
    var box = badge.parentNode;
    var flagEl = box ? box.querySelector('[data-ship-flag]') : null;
    if (flagEl) {
      var country = visitorCountry();
      flagEl.setAttribute('data-country', country);
      flagEl.setAttribute('aria-label', country === 'NZ' ? 'New Zealand' : 'Australia');
    }
  }
  function init() {
    var badges = document.querySelectorAll('[data-ship-badge]');
    for (var i = 0; i < badges.length; i++) render(badges[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
